<form *ngIf="promoCodeFrom" [formGroup]="promoCodeFrom" class="bg-white p-4">
  <div class="border-bottom border-2 px-4 pt-2">
    <h3>{{ editMode ? "Edit System Promo Code" : "Create System Promo Code" }}</h3>
  </div>
  <div class="p-4">
    <div class="form-group row">
      <div class="col-md-4 mb-3">
        <label>Name <span class="text-danger">*</span></label>
        <input type="text" placeholder="Promocode Name"
               class="form-control"
               formControlName="codeName"
               [attr.disabled]="editMode ? '': null" />
        <small class="text-danger" *ngIf="formValidator.formErrors.codeName">
          {{formValidator?.formErrors?.codeName}}
        </small>
      </div>
      <div class="col-md-4 mb-3">
        <label>Quantity <span class="text-danger">*</span></label>
        <input type="number" class="form-control" min="1" formControlName="availableQuantity" placeholder="Promocode Quantity" />
        <small class="text-danger" *ngIf="formValidator.formErrors.availableQuantity">
          {{formValidator?.formErrors?.availableQuantity}}
        </small>
      </div>
      <div class="col-md-4 mb-3">
        <label>Business Limit Quantity <span class="text-danger">*</span></label>
        <input type="number" class="form-control" min="1" formControlName="businessLimitQuantity" placeholder="Promocode Quantity limit per business" />
        <small class="text-danger" *ngIf="formValidator.formErrors.businessLimitQuantity">
          {{formValidator?.formErrors?.businessLimitQuantity}}
        </small>
      </div>
      <div class="col-md-4 mb-3">
        <label>Expiry <span class="text-danger">*</span></label>
        <div class="input-group">
          <input id="inDate"
                 type="datetime"
                 class="form-control"
                 formControlName="expiry"
                 [matDatepicker]="picker"
                 placeholder="MM/DD/YYYY"
                 (click)="picker.open()" />
          <mat-datepicker-toggle style="position: absolute; right: 0px; z-index:20"
                                 [for]="picker"></mat-datepicker-toggle>
        </div>
        <mat-datepicker #picker startView="month" [startAt]="Datenow"></mat-datepicker>
        <small class="text-danger" *ngIf="formValidator.formErrors.expiry">
          {{formValidator?.formErrors?.expiry}}
        </small>
      </div>
      <div class="col-md-4 mb-3">
        <label>Payment Options</label>
        <select class="form-control form-select"
                [attr.disabled]="editMode ? '': null"
                placeholder="Payment Options"
                formControlName="PaymentOptionId">
          <option *ngFor="let option of paymentOptions" [value]="option.id">
            {{ option.name }}
          </option>
        </select>
        <small class="text-danger" *ngIf="formValidator.formErrors.PaymentOptionId">
          {{formValidator?.formErrors?.PaymentOptionId}}
        </small>
      </div>
      <div class="col-md-4 mb-3">
        <label>Percentage <span class="text-danger">*</span></label>
        <input type="number" min="1" max="100" placeholder="Percentage"
               class="form-control" formControlName="precentage" [attr.disabled]="editMode ? '': null" />
        <small class="text-danger" *ngIf="formValidator.formErrors.precentage">
          {{formValidator?.formErrors?.precentage}}
        </small>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-4 mb-3">
        <label>Description</label>
        <input class="form-control" type="text" formControlName="description" placeholder="Description" />
        <small class="text-danger" *ngIf="formValidator.formErrors.description">
          {{formValidator?.formErrors?.description}}
        </small>
      </div>

	  <div class="col mb-3">
		  <mat-form-field appearance="outline" class="w-100">
			  <mat-label>{{ 'Sellers.Products.MaxValue' | translate }}</mat-label>
			  <input type="number" min="1" matInput class="form-control" formControlName="maxPrecentageValue"
			  placeholder="{{ 'Sellers.Products.MaxValue' | translate }}" [attr.disabled]="editMode ? '': null" />
			  <mat-error class="text-danger" *ngIf="formValidator?.formErrors?.maxPrecentageValue">
				  {{formValidator.formErrors.maxPrecentageValue}}
			  </mat-error>
		  </mat-form-field>
	  </div>

    </div>

    <div class="mt-3">
      <p class="text-danger d-inline-block" *ngIf="error">
        {{error}}
      </p>

      <button class="btn btn-primary" (click)="onSubmit(promoCodeFrom.value)"
              type="button" [disabled]="promoCodeFrom.invalid">
        Submit
      </button>
    </div>
  </div>
</form>
